import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

function formatDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}

export default function ArticlesListPage() {
  const { user } = useAuth();
  const isAdmin = Boolean(user?.is_staff || user?.is_admin);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/articles/');
        if (!cancelled) {
          setArticles(Array.isArray(res.data) ? res.data : []);
        }
      } catch {
        if (!cancelled) {
          setError('Не удалось загрузить статьи.');
          setArticles([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="articles-page">
      <div className="page-header articles-page-header">
        <div>
          <h1>Статьи</h1>
          <p className="text-secondary">
            Разборы решений и заметки про образование. Полный текст и код — здесь.
          </p>
        </div>
        {isAdmin && (
          <Link to="/admin/articles" className="btn btn-outline btn-sm">
            Управление
          </Link>
        )}
      </div>

      {loading && <p className="text-secondary">Загрузка…</p>}
      {error && <p className="form-error">{error}</p>}
      {!loading && !error && articles.length === 0 && (
        <p className="text-secondary">Пока нет опубликованных статей.</p>
      )}

      <ul className="articles-list">
        {articles.map((a) => (
          <li key={a.slug} className="articles-list-item">
            <Link to={`/articles/${encodeURIComponent(a.slug)}`} className="articles-list-link">
              {a.cover_url ? (
                <img src={a.cover_url} alt="" className="articles-list-cover" loading="lazy" />
              ) : null}
              <div className="articles-list-body">
                <h2 className="articles-list-title">{a.title}</h2>
                {a.summary ? <p className="articles-list-summary">{a.summary}</p> : null}
                <p className="articles-list-meta text-secondary">
                  {formatDate(a.published_at)}
                  {a.author_name ? ` · ${a.author_name}` : ''}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
